import { authenticatedAxiosInstance } from "../../../auth/AuthenticatedAxios"
import { AbsencePost, AbsenceType } from "../types"
import { API } from "../../../api/constants"
export const getAbsenceById = (id: string) => authenticatedAxiosInstance.get(`/absence/${id}`).then((res) => res.data)

export const addAbsence = (data: AbsencePost) => authenticatedAxiosInstance.post(API + `/absence`, data).then((res) => res.data)

export const updateAbsenceById = (data: { id: string; body: AbsenceType }) =>
    authenticatedAxiosInstance.patch(API + `/absence/${data.id}`, data.body).then((res) => res.data)

export const solveConflictAbsence = (data: { parentId: string; conflictId: string }) =>
    authenticatedAxiosInstance.patch(API + `/absence/solve-conflict/${data.parentId}/${data.conflictId}`).then((res) => res.data)

export const getAbsencesByEmployeeId = (employeeId: string, startDate: string, endDate: string) =>
    authenticatedAxiosInstance.get(API + `/absence/${employeeId}?startDate=${startDate}&endDate=${endDate}`).then((res) => res.data)
